import { TRAFFIC_LIGHT_COLOURS as COLOURS, safetyLegend } from '@src/modules/performance/shared/constants';
import {
  Box, Flex, Link, Text,
} from '@chakra-ui/react';

import { useSafetyKPI } from '@src/modules/performance/context/map-api-hooks';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import ReportHeader from './ReportHeader';

const subheader = 'Deaths and Serious Injuries (DSI)';
const informationSource = {
  title: 'Road Safety',
  content: [
    {
      title: 'Deaths and Serious Injuries (10 Year Annual Avg)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The annual average number of deaths and serious injuries (DSI) for the last ten financial years, including the trend for the same period based on the change on the quantity as below:
    </Text>
    <IndicatorLegend items={safetyLegend} />
    <Text fontSize="inherit" mt={2}>
      Road Efficiency Group Te Ringa Maimoa has calculated these results
    </Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Source from
    {' '}
    <Link href="https://www.nzta.govt.nz/partners/data-and-tools/crash-analysis-system" isExternal>NZTA Crash Analysis System</Link>
  </Text>,
    },
  ],
};

function RoadSafetyReportHeader({ ...rest }) {
  const { data: safetyData, isLoadingKpi } = useSafetyKPI();

  return (
    <ReportHeader
      title="Road Safety"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      <Flex align="center">
        <Box mr={3}>
          <CircleIndicator
            size={60}
            colour={COLOURS[safetyData?.colour]}
            value={safetyData?.value}
            isLoading={isLoadingKpi && !safetyData}
          />
        </Box>
        <Box pr={15}>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            Deaths and Serious Injuries / Trend
            <br />
            <Text as="span" fontSize="xs" color="gray">
              (
              {safetyData?.averageYearRange}
              {' '}
              Annual Avg)
            </Text>
          </Text>
        </Box>
      </Flex>
    </ReportHeader>
  );
}

export default RoadSafetyReportHeader;
